import axios, { AxiosResponse } from 'axios';

export const isAxiosError = (error: unknown): any => {
  return error !== null && axios.isAxiosError(error);
};

export const isAxiosResponse = (value: unknown): value is AxiosResponse => {
  return typeof value === 'object' && value !== null && 'data' in value;
};
